import { TIMESPAN } from '@/enums/timespan';

export const dataButtonFiltre = [
  {
    // Default
    text: '1 semaine',
    textMobile: '1S',
    value: TIMESPAN.week,
    // Immobilier
    textImmo: '5 ans',
    valueImmo: TIMESPAN.fiveYears,
    tracking: {
      event_id: 'clic',
      event_categorie: 'clic',
      event_metier: 'espace client placement',
      event_nom: '1 semaine',
      event_detail_1: 'filtre graphique',
    },
    trackingImmo: {
      event_id: 'clic',
      event_categorie: 'clic',
      event_metier: 'espace client placement',
      event_nom: '5 ans',
      event_detail_1: 'filtre graphique',
    },
  },
  {
    // Default
    text: '1 mois',
    textMobile: '1M',
    value: TIMESPAN.month,
    // Immobilier
    textImmo: '10 ans',
    valueImmo: TIMESPAN.tenYears,
    tracking: {
      event_id: 'clic',
      event_categorie: 'clic',
      event_metier: 'espace client placement',
      event_nom: '1 mois',
      event_detail_1: 'filtre graphique',
    },
    trackingImmo: {
      event_id: 'clic',
      event_categorie: 'clic',
      event_metier: 'espace client placement',
      event_nom: '10 ans',
      event_detail_1: 'filtre graphique',
    },
  },
  {
    // Default
    text: 'YTD',
    textMobile: 'YTD',
    value: TIMESPAN.year,
    // Immobilier
    textImmo: '15 ans',
    valueImmo: TIMESPAN.fifteenYears,
    tracking: {
      event_id: 'clic',
      event_categorie: 'clic',
      event_metier: 'espace client placement',
      event_nom: 'YTD',
      event_detail_1: 'filtre graphique',
    },
    trackingImmo: {
      event_id: 'clic',
      event_categorie: 'clic',
      event_metier: 'espace client placement',
      event_nom: '15 ans',
      event_detail_1: 'filtre graphique',
    },
  },
  {
    // Default
    text: 'MAX',
    textMobile: 'MAX',
    value: TIMESPAN.allTime,
    // Immobilier
    textImmo: 'MAX',
    valueImmo: TIMESPAN.allTime,
    tracking: {
      event_id: 'clic',
      event_categorie: 'clic',
      event_metier: 'espace client placement',
      event_nom: 'MAX',
      event_detail_1: 'filtre graphique',
    },
    trackingImmo: {
      event_id: 'clic',
      event_categorie: 'clic',
      event_metier: 'espace client placement',
      event_nom: 'MAX',
      event_detail_1: 'filtre graphique',
    },
  },
];
